module.exports = __webpack_public_path__ + "static/media/3DPPA35.5c9e04ea.jpg";